export class InboxSearchDTO {
    public searchId: any;
    public searchInput: String;
    public startDate: String;
    public endDate: String;
}